import {FC, useState} from 'react';
import {SelectWithSearch} from '@deviceinsight/ng-ui-components';
import {SpinnerContainer} from '@deviceinsight/ng-ui-basic-components';
import './CustomerSelect.less';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';

import {Subtenant} from '../../modules/subtenants/types';

type Item = {
	type: 'item';
	value: string;
	label: string;
};

export type Props = {
	loading: boolean;
	customers: Subtenant[];
	onSelectedItem: (i: Item | null) => void;
};

const CustomerSelect: FC<Props> = ({loading, customers, onSelectedItem}) => {
	const [selectedItem, setSelectedItem] = useState<Item | null>();

	const options = customers.map((c) => {
		return {type: 'item', label: c.organisation.name, value: c.id.toString()};
	});

	return (
		<div className="customer-select" style={{marginBottom: 30}}>
			<label>
				<strong>
					<Trans i18nKey="kisapi.customerselect.title">Customer:</Trans>
				</strong>
			</label>
			<SpinnerContainer show={loading}>
				<div style={{width: 200}} data-testid="customer-select">
					<SelectWithSearch
						options={options as Item[]}
						value={selectedItem}
						onChange={(i) => {
							setSelectedItem(i);
							onSelectedItem(i ?? null);
						}}></SelectWithSearch>
				</div>
			</SpinnerContainer>
		</div>
	);
};

export default CustomerSelect;
